<template>
    <base-box padding="none" clickable>
        <template slot="content">
            <div v-if="imageUrls.length > 1" class="product-list-item-image-carousel">
                <g-carousel :img-urls="imageUrls" lazy-load @click="handleClick" />
            </div>
            <div v-else class="product-list-item-image" @click="handleClick">
                <g-image-thumbnail
                    :image-link="imageUrl"
                    image-description="product image"
                    image-units-string="%"
                    background-color="$g-color-grey-1"
                    :background-blur="false"
                />
            </div>
            <div class="content-area" @click="handleClick">
                <g-typography tag="h3" font-weight="semibold" text-overflow="ellipsis">
                    {{ product.name }}
                </g-typography>
                <g-typography v-if="showPrice" tag="p">
                    {{ price }}
                </g-typography>
                <g-typography v-if="!inStock" color="error">
                    Out of Stock
                </g-typography>
            </div>
        </template>
    </base-box>
</template>

<script>
import {PLACEHOLDER_IMAGE} from '../../../../constants/cdn-assets';
    import {formatCurrency} from '../../../../helpers/formatters';
    import ProductImageMixin from '../mixins/ProductImageMixin';

    export default {
        name:   'ProductListItem',
        mixins: [
            ProductImageMixin,
        ],
        props: {
            product: {
                type: Object,
            },
            showPrice: {
                type:    Boolean,
                default: true,
            },
            currency: {
                type:    String,
                default: '',
            },
        },
        computed: {
            imageUrl() {
                return this.product.image || PLACEHOLDER_IMAGE;
            },
            imageUrls() {
                return this.getImageUrls(this.product);
            },
            price() {
                return formatCurrency(this.product.price, this.currency);
            },
            inStock() {
                return !!this.product.is_in_stock;
            },
        },
        methods: {
            handleClick() {
                this.$emit('click', this.product);
            },
        },
    };
</script>

<style lang="scss" scoped>
    .content-area {
        padding: $g-spacing-4;
        min-height: 91px;
        border-top: 1px solid $g-color-grey-4;
    }
    .product-list-item-image {
        height: 230px;
        width: 100%;
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
    }
    .product-list-item-image-carousel {
        height: 230px;
        width: 100%;
    }
</style>
